

import Slide from './slide'




/**
 * Slider
 */
class Slider {
    constructor(node) {
        console.log('Slider constructor(node)', node);

        this.node = node;
        this.slides = {};

        this.currentSlide;


        // this.animating;
        // this.nextSlide
        // this.previousSlide;
        // this.left;
        // this.opacity;
        // this.scale;

        // let form = node.querySelector('form');
        // form.addEventListener('change', this, false);

        // this.init();
        [...node.querySelectorAll('[data-slider-slide]')].forEach(slideNode => {
            let slide = new Slide(slideNode);
            this.slides[slide.getName()] = slide;
        });


        node.addEventListener('click', this, false);
    }

    handleEvent(event) {
        console.info('Slider.handleEvent() [event]', event);

        const target = event.target;

        switch (event.type) {
            case 'click':
                // console.log();
                if (target.dataset.sliderNext) {
                    this.next(target.dataset.sliderNext);
                }

                if (target.dataset.sliderPrev) {
                    this.prev(target.dataset.sliderPrev);
                }
        }
    }

    getSlides() {
        console.info('Slider.getSlides()');

        return this.slides; 
    }

    getSlide(name) {
        console.info('Slider.getSlide(name) [name]', name);

        return this.slides[name]; 
    }

    next(name) {
        console.info('Slider.next(name) [name]', name);

        const nextSlide = this.slides[name];

        let result = nextSlide.load();

        if (!result) {
            return;
        }

        this.currentSlide.unload();
        this.currentSlide = nextSlide;
    }

    prev(name) {
        console.info('Slider.prev(name) [name]', name);

        const previousSlide = this.slides[name];

        let result = previousSlide.load();

        if (!result) {
            return;
        }
        
        this.currentSlide.unload();
        this.currentSlide = previousSlide;
    }

    start(name) {
        console.info('Slider.start(name) [name]', name);

        if (this.slides[name]) {
            this.currentSlide = this.slides[name];
            this.currentSlide.load();
        }
    }
}


export default Slider;

